"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrollmentProcessor = void 0;
var react_1 = __importDefault(require("react"));
var update_user_facetec_1 = require("../../../app/api/calls/user/update_user_facetec");
var Config_1 = require("../../../app/Config");
var content_dialog_1 = require("../../../app/features/thunks/content-dialog");
var store_1 = require("../../../app/store");
var firebase_1 = require("../../../app/utils/firebase");
var DeveloperStatusMessages_1 = require("../utilities/DeveloperStatusMessages");
var FaceTecSDK_1 = require("./../../../core-sdk/FaceTecSDK.js/FaceTecSDK");
// Error dialog component for FaceTec enrollment failures
var FaceTecErrorDialog = function (_a) {
    var message = _a.message, referenceId = _a.referenceId;
    var _b = react_1.default.useState(false), copied = _b[0], setCopied = _b[1];
    var handleCopy = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(referenceId)];
                case 1:
                    _a.sent();
                    setCopied(true);
                    setTimeout(function () { return setCopied(false); }, 2000);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.error("Failed to copy:", err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return react_1.default.createElement("div", { className: "p-4 space-y-4" }, react_1.default.createElement("div", { className: "flex items-center gap-2 text-red-600" }, react_1.default.createElement("svg", {
        className: "w-6 h-6",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
    }, react_1.default.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z",
    })), react_1.default.createElement("span", { className: "font-semibold" }, "Enrolment Failed")), react_1.default.createElement("p", { className: "text-gray-700 text-sm" }, message), react_1.default.createElement("div", { className: "bg-gray-100 rounded-lg p-3 space-y-2" }, react_1.default.createElement("p", { className: "text-xs text-gray-500 font-medium" }, "Reference ID:"), react_1.default.createElement("div", { className: "flex items-center gap-2" }, react_1.default.createElement("code", {
        className: "text-xs bg-white px-2 py-1 rounded border flex-1 overflow-x-auto",
    }, referenceId), react_1.default.createElement("button", {
        onClick: handleCopy,
        className: "px-3 py-1 text-xs font-medium rounded " +
            (copied
                ? "bg-green-500 text-white"
                : "bg-blue-500 text-white hover:bg-blue-600"),
    }, copied ? "Copied!" : "Copy"))), react_1.default.createElement("p", { className: "text-xs text-gray-500" }, "Please contact support with this reference ID if the problem persists."));
};
// Helper function to show enrollment error dialog (only in dev environments)
function showEnrollmentErrorDialog(message, referenceId) {
    var isDevEnv = ["LOCAL", "DEV"].includes(process.env.ENVIRONMENT || "");
    if (!isDevEnv) {
        return;
    }
    store_1.store.dispatch((0, content_dialog_1.showContentDialogThunk)({
        header: "Facial Recognition Enrolment Error",
        content: react_1.default.createElement(FaceTecErrorDialog, {
            message: message,
            referenceId: referenceId,
        }),
        width: "normal",
        closable: true,
    }));
}
var EnrollmentProcessor = /** @class */ (function () {
    function EnrollmentProcessor(sessionToken, sampleAppControllerReference) {
        var _this = this;
        this.latestNetworkRequest = new XMLHttpRequest();
        //
        // Part 2:  Handling the Result of a FaceScan
        //
        this.processSessionResultWhileFaceTecSDKWaits = function (sessionResult, faceScanResultCallback) {
            _this.latestSessionResult = sessionResult;
            //
            // Part 3:  Handles early exit scenarios where there is no FaceScan to handle -- i.e. User Cancellation, Timeouts, etc.
            //
            if (sessionResult.status !==
                FaceTecSDK_1.FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully) {
                console.log("Session was not completed successfully, cancelling.  Session Status: " +
                    FaceTecSDK_1.FaceTecSDK.FaceTecSessionStatus[sessionResult.status]);
                _this.latestNetworkRequest.abort();
                faceScanResultCallback.cancel();
                return;
            }
            // IMPORTANT:  FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully DOES NOT mean the Enrollment was Successful.
            // It simply means the User completed the Session and a 3D FaceScan was created.  You still need to perform the Enrollment on your Servers.
            //
            // Part 4:  Get essential data off the FaceTecSessionResult
            //
            //Call getLatestEnrollmentIdentifier and save it in the DB
            //
            var externalDatabaseRefID = _this.sampleAppControllerReference.getLatestEnrollmentIdentifier();
            var parameters = {
                faceScan: sessionResult.faceScan,
                auditTrailImage: sessionResult.auditTrail[0],
                lowQualityAuditTrailImage: sessionResult.lowQualityAuditTrail[0],
                externalDatabaseRefID: externalDatabaseRefID,
            };
            //
            // Part 5:  Make the Networking Call to Your Servers.  Below is just example code, you are free to customize based on how your own API works.
            //
            // Get Firebase ID token for v2 endpoint authentication, then make the request
            var currentUser = firebase_1.auth.currentUser;
            var tokenPromise = currentUser
                ? currentUser.getIdToken()
                : Promise.resolve(null);
            tokenPromise
                .then(function (firebaseIdToken) {
                var enrollmentUrl = Config_1.Config.BaseURLV2 + "/enrollment-3d";
                _this.latestNetworkRequest = new XMLHttpRequest();
                _this.latestNetworkRequest.open("POST", enrollmentUrl);
                _this.latestNetworkRequest.setRequestHeader("Content-Type", "application/json");
                // Add Authorization header with Firebase ID token (required for v2 endpoint)
                if (firebaseIdToken) {
                    _this.latestNetworkRequest.setRequestHeader("Authorization", "Bearer ".concat(firebaseIdToken));
                }
                _this.latestNetworkRequest.setRequestHeader("X-Device-Key", Config_1.Config.DeviceKeyIdentifier);
                _this.latestNetworkRequest.setRequestHeader("X-User-Agent", FaceTecSDK_1.FaceTecSDK.createFaceTecAPIUserAgentString(sessionResult.sessionId));
                _this.latestNetworkRequest.onreadystatechange =
                    function () { return __awaiter(_this, void 0, void 0, function () {
                        var parsedResponse, responseJSON, scanResultBlob, errorMessage, isSuccessful, firebaseResult, _e_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(this.latestNetworkRequest.readyState === XMLHttpRequest.DONE)) return [3 /*break*/, 6];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 5, , 6]);
                                    parsedResponse = JSON.parse(this.latestNetworkRequest.responseText);
                                    responseJSON = parsedResponse.content || parsedResponse;
                                    scanResultBlob = responseJSON.scanResultBlob;
                                    // Check if the API returned an explicit error (success: false)
                                    if (parsedResponse.success === false ||
                                        responseJSON.success === false) {
                                        errorMessage = parsedResponse.message ||
                                            responseJSON.message ||
                                            "Unknown enrolment error";
                                        // Show error dialog to user with the reference ID
                                        showEnrollmentErrorDialog(errorMessage, externalDatabaseRefID);
                                        this.cancelDueToNetworkError(errorMessage, faceScanResultCallback);
                                        return [2 /*return*/];
                                    }
                                    isSuccessful = responseJSON.wasProcessed === true ||
                                        parsedResponse.success === true ||
                                        responseJSON.success === true;
                                    if (!isSuccessful) return [3 /*break*/, 3];
                                    return [4 /*yield*/, (0, update_user_facetec_1.update_user_facetec)({
                                            responseJSON: __assign(__assign({}, responseJSON), { wasProcessed: true }), // Ensure wasProcessed is set for downstream
                                            facetecDBRef: externalDatabaseRefID,
                                        })];
                                case 2:
                                    firebaseResult = _a.sent();
                                    if (!firebaseResult.success) {
                                        // Show error dialog for Firebase save failure
                                        showEnrollmentErrorDialog(firebaseResult.message ||
                                            "Failed to save enrolment to database.", externalDatabaseRefID);
                                        this.cancelDueToNetworkError("Failed to save enrollment to database. Please try again.", faceScanResultCallback);
                                        return [2 /*return*/];
                                    }
                                    // Demonstrates dynamically setting the Success Screen Message.
                                    FaceTecSDK_1.FaceTecSDK.FaceTecCustomization.setOverrideResultScreenSuccessMessage("Liveness\nConfirmed");
                                    // In v9.2.0+, simply pass in scanResultBlob to the proceedToNextStep function to advance the User flow.
                                    // scanResultBlob is a proprietary, encrypted blob that controls the logic for what happens next for the User.
                                    // If scanResultBlob exists, use it; otherwise just complete the flow
                                    if (scanResultBlob) {
                                        faceScanResultCallback.proceedToNextStep(scanResultBlob);
                                    }
                                    else {
                                        faceScanResultCallback.proceedToNextStep(null);
                                    }
                                    return [3 /*break*/, 4];
                                case 3:
                                    // CASE:  UNEXPECTED response from API.
                                    // Show error dialog for unexpected response
                                    showEnrollmentErrorDialog("The enrolment could not be processed. Please try again.", externalDatabaseRefID);
                                    this.cancelDueToNetworkError("Unexpected API response, cancelling out.", faceScanResultCallback);
                                    _a.label = 4;
                                case 4: return [3 /*break*/, 6];
                                case 5:
                                    _e_1 = _a.sent();
                                    // CASE:  Parsing the response into JSON failed
                                    this.cancelDueToNetworkError("Exception while handling API response, cancelling out.", faceScanResultCallback);
                                    return [3 /*break*/, 6];
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); };
                _this.latestNetworkRequest.onerror = function () {
                    // CASE:  Network Request itself is erroring --> You define your own API contracts with yourself and may choose to do something different here based on the error.
                    _this.cancelDueToNetworkError("XHR error, cancelling.", faceScanResultCallback);
                };
                //
                // Part 7:  Demonstrates updating the Progress Bar based on the progress event.
                //
                _this.latestNetworkRequest.upload.onprogress = function (event) {
                    var progress = event.loaded / event.total;
                    faceScanResultCallback.uploadProgress(progress);
                };
                //
                // Part 8:  Actually send the request.
                //
                var jsonStringToUpload = JSON.stringify(parameters);
                _this.latestNetworkRequest.send(jsonStringToUpload);
                //
                // Part 9:  For better UX, update the User if the upload is taking a while.  You are free to customize and enhance this behavior to your liking.
                //
                window.setTimeout(function () {
                    if (_this.latestNetworkRequest.readyState === XMLHttpRequest.DONE) {
                        return;
                    }
                    faceScanResultCallback.uploadMessageOverride("Still Uploading...");
                }, 6000);
            })
                .catch(function () {
                _this.cancelDueToNetworkError("Failed to get authentication token.", faceScanResultCallback);
            });
        };
        //
        // Part 10:  This function gets called after the FaceTec SDK is completely done.  There are no parameters because you have already been passed all data in the processSessionWhileFaceTecSDKWaits function and have already handled all of your own results.
        //
        this.onFaceTecSDKCompletelyDone = function () {
            //
            // DEVELOPER NOTE:  onFaceTecSDKCompletelyDone() is called after you signal the FaceTec SDK with success() or cancel().
            // Calling a custom function on the Sample App Controller is done for demonstration purposes to show you that here is where you get control back from the FaceTec SDK.
            //
            _this.success = _this.latestSessionResult.isCompletelyDone;
            // Log success message
            if (_this.success) {
                DeveloperStatusMessages_1.DeveloperStatusMessages.logMessage("Liveness Confirmed");
            }
            // If enrollment was not successful, clear the enrollment identifier
            else {
                _this.sampleAppControllerReference.clearLatestEnrollmentIdentifier();
            }
            _this.sampleAppControllerReference.onComplete(_this.latestSessionResult, null, _this.latestNetworkRequest.status);
        };
        // Helper function to ensure the session is only cancelled once
        this.cancelDueToNetworkError = function (networkErrorMessage, faceScanResultCallback) {
            if (_this.cancelledDueToNetworkError === false) {
                _this.cancelledDueToNetworkError = true;
                faceScanResultCallback.cancel();
            }
        };
        //
        // DEVELOPER NOTE:  This public convenience method is for demonstration purposes only so the Sample App can get information about what is happening in the processor.
        // In your code, you may not even want or need to do this.
        //
        this.isSuccess = function () {
            return _this.success;
        };
        //
        // DEVELOPER NOTE:  These properties are for demonstration purposes only so the Sample App can get information about what is happening in the processor.
        // In the code in your own App, you can pass around signals, flags, intermediates, and results however you would like.
        //
        this.success = false;
        this.sampleAppControllerReference = sampleAppControllerReference;
        this.latestSessionResult = null;
        this.cancelledDueToNetworkError = false;
        //
        // Part 1:  Starting the FaceTec Session
        //
        // Required parameters:
        // - FaceTecFaceScanProcessor:  A class that implements FaceTecFaceScanProcessor, which handles the FaceScan when the User completes a Session.  In this example, "this" implements the class.
        // - sessionToken:  A valid Session Token you just created by calling your API to get a Session Token from the Server SDK.
        //
        new FaceTecSDK_1.FaceTecSDK.FaceTecSession(this, sessionToken);
    }
    return EnrollmentProcessor;
}());
exports.EnrollmentProcessor = EnrollmentProcessor;
